import { configureValues, values } from 'bundles/apex/deals/config';
import { defaultViewConfig } from './config';
import { GROSS_AMOUNT_KEY, optionalKeys } from 'bundles/apex/pipeline/config';

export function getInitialColumnOptions(fieldsByName, columns) {
  configureValues(fieldsByName);

  const keys = [
    ...optionalKeys,
    ...Object.keys(values).filter(key => fieldsByName[key]?.custom)
  ];

  const options = keys
    .map(key => ({ label: labelFor(key), value: key }))
    .sort((option1, option2) => option1.label.localeCompare(option2.label));

  const selectedKeys = columns || defaultViewConfig.columns;
  return {
    all: options,
    available: options.filter(option => !selectedKeys.includes(option.value)),
  };
}

function labelFor(key) {
  return key === GROSS_AMOUNT_KEY ? 'Broker / Brokerage Gross' : values[key].label;
}

export function getSelectOptions(all = [], available = [], selectedValue) {
  const selected = all.find(option => option.value === selectedValue);
  if (!selected) return ['', ...available];

  return available.concat(selected).sort((a, b) => a.label.localeCompare(b.label));
} 
